import useGenericContentStore from "../../store/genericContent.store";
import { globalAny } from "../../utils/Utils";
import { Props } from "./model";
import { StyledStudioAccessBanner, StyledText, StyledTextContainer } from "./styled";

const Banner = (props: Props) => {
	const isNarrow = useGenericContentStore((state) => state.isNarrow);

	return (
		//@ts-ignore
		<StyledStudioAccessBanner banner={props.banner} isNarrow={isNarrow}>
			{/* @ts-ignore */}
			<StyledTextContainer isNarrow={isNarrow}>
				{/* @ts-ignore */}
				<StyledText isNarrow={isNarrow}>{globalAny.language.banner_text}</StyledText>
			</StyledTextContainer>
		</StyledStudioAccessBanner>
	);
};

export default Banner;
